import { UserButton } from '@clerk/clerk-react';
import BottomNavigation from '../ui/BottomNavigation';
import ReviewModeBanner from '../features/dashboard/ReviewModeBanner';
import StationImportStrip from '../features/agents/StationImportStrip';

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-animated pb-20">
      <div className="bg-gradient-orb-1" aria-hidden="true" />
      <div className="bg-gradient-orb-2" aria-hidden="true" />

      <ReviewModeBanner />
      <StationImportStrip />

      <div className="fixed top-3 right-4 z-50" data-testid="profile-icon">
        <UserButton
          afterSignOutUrl="/sign-in"
          appearance={{
            elements: {
              avatarBox: 'w-9 h-9 ring-2 ring-white/20 hover:ring-white/40 transition-all',
            },
          }}
        />
      </div>

      <div className="relative min-h-screen">
        {children}
      </div>

      <BottomNavigation />
    </div>
  );
}
